export const messages = {
  en: {
    assetInventoryEdit: {
      title: 'Inventory Edit',
      inventoryInfo: 'Inventory Information',
      inventoryName: 'Inventory Name',
      inventoryPerson: 'Inventory Person',
      warehouse: 'Warehouse',
      inventoryDate: 'Inventory Date',
      remark: 'Remark',
      inventoryProducts: 'Inventory Products',
      products: 'Products',
      productType: 'Product Type',
      productName: 'Product Name',
      specification: 'Specification',
      productCode: 'Product Code',
      isFixed: 'Is Fixed',
      referencePrice: 'Reference Price',
      stock: 'Stock',
      afterInventoryQty: 'After Inventory Qty',
      requiredQty: 'Required Qty',
      optionalRemark: 'Optional Remark',
      selectPrice: 'Select Price',
      selectWarehouseFirst: 'Please select warehouse first',
      selectProductsFirst: 'Please select products first',
      fillQty: 'Please fill quantity',
      submitError: 'Submit failed',
      fetchError: 'Failed to get inventory info',
      fetchProductError: 'Failed to get product list'
    }
  },
  zh: {
    assetInventoryEdit: {
      title: '盘点编辑',
      inventoryInfo: '盘点信息',
      inventoryName: '盘点名称',
      inventoryPerson: '盘点人',
      warehouse: '选择仓库',
      inventoryDate: '盘点日期',
      remark: '盘点说明',
      inventoryProducts: '盘点商品',
      products: '商品',
      productType: '物品类型',
      productName: '物品名称',
      specification: '物品规格',
      productCode: '物品编码',
      isFixed: '是否是固定物品',
      referencePrice: '参考价格',
      stock: '物品库存',
      afterInventoryQty: '盘点后数量',
      requiredQty: '必填，请填盘点后数量',
      optionalRemark: '选填，请填写备注',
      selectPrice: '请选择价格',
      selectWarehouseFirst: '请先选择仓库',
      selectProductsFirst: '请选择商品',
      fillQty: '请填写数量',
      submitError: '提交失败',
      fetchError: '获取盘点信息失败',
fetchProductError: '获取商品列表失败'
    }
  },
  'zh-TW': {
    assetInventoryEdit: {
      title: '盤點編輯',
      inventoryInfo: '盤點信息',
      inventoryName: '盤點名稱',
      inventoryPerson: '盤點人',
      warehouse: '選擇倉庫',
      inventoryDate: '盤點日期',
      remark: '盤點說明',
      inventoryProducts: '盤點商品',
      products: '商品',
      productType: '物品類型',
      productName: '物品名稱',
      specification: '物品規格',
      productCode: '物品編碼',
      isFixed: '是否是固定物品',
      referencePrice: '參考價格',
      stock: '物品庫存',
      afterInventoryQty: '盤點後數量',
      requiredQty: '必填，請填盤點後數量',
      optionalRemark: '選填，請填寫備註',
      selectPrice: '請選擇價格',
      selectWarehouseFirst: '請先選擇倉庫',
      selectProductsFirst: '請選擇商品',
      fillQty: '請填寫數量',
      submitError: '提交失敗',
      fetchError: '獲取盤點信息失敗',
      fetchProductError: '獲取商品列表失敗'
    }
  }
}